/*@ngInject*/
module.exports = function($rootScope, $uibModal, publicRoutesService, publicUsersService, clipboard, publicObjectsService, FileSaver) {
	return {
		scope: {
			routeId: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			let vm = this;
			vm.commentError = !$rootScope.currentUser;
			vm.userNotLoggedIn = !$rootScope.currentUser;
			vm.copyToClipboardSupported = true;
			vm.showObjects = false;
			vm.mapLoaded = false;
			vm.addCommentMessage = !$rootScope.currentUser ? 'Kommentaari lisamiseks ' : '';
			vm.userHasBookmark = false;
			vm.showSuggestionAddedMessage = false;
			vm.showSuggestionErrorMessage = false;
			vm.addingSuggestionsAllowed = false;
			vm.emptyCommentError = false;
			vm.commentAddError = false;
			vm.commentAddErrorMessage = '';
			vm.commentAddSuccess = false;

			vm.$onInit = function(){
				vm.copyToClipboardSupported = clipboard.supported;

				publicRoutesService.getRouteDataById(vm.routeId).then((response) => {
					vm.routeData = response.data;
					vm.routeData.objectType = publicObjectsService.TYPE_ROUTE;

					publicUsersService.userHasBookmark(vm.routeData.route_id, publicObjectsService.TYPE_ROUTE).then(
						result => vm.userHasBookmark = result.data);

					vm.commentsAllowed = response.data.comments_allowed;
					vm.addingSuggestionsAllowed = response.data.suggestions_allowed;
					vm.getRouteFileNames(vm.routeData.image_files);
				});
			};

			vm.openSuggestionModal = () => {
				vm.showSuggestionAddedMessage = false;
				vm.showSuggestionErrorMessage = false;
				const modalInstance = $uibModal.open({
					template: require('../../suggestions/object-suggestion-modal.directive.html'),
					controller: require('../../suggestions/object-suggestion-modal.directive'),
					controllerAs: 'vm',
					size: 'lg',
					backdrop: 'static',
					keyboard: false,
					windowClass: 'center-modal',
					resolve: {
						data () {
							return {object: vm.routeData, objectType: 'ROUTE' };
						}
					}
				});

				modalInstance.result.then((result) => {
					if(result === 'ok'){
						vm.showSuggestionAddedMessage = true;
					} else {
						vm.showSuggestionErrorMessage = true;
					}
				});
			};

			vm.logIn = () => $rootScope.logIn();

			vm.downloadRouteGpxFile = () => {
				publicRoutesService.getRouteGpxContent(vm.routeId).then((response) => {
					FileSaver.saveAs(new Blob([response.data], { type: 'text/xml;charset=utf-8' }), 'route.gpx');
				});
			};

			vm.getRouteFileNames = (imageFiles) => {
				angular.forEach(imageFiles, (imageFile) => {
					imageFile.fileName = imageFile.name ? _.find(imageFile.name, {language: 'est'}).value : '';
				});
			};

			vm.updateBookmark = function(routeId) {
				publicUsersService.updateBookmark(publicObjectsService.TYPE_ROUTE, routeId).then(result => {
					vm.userHasBookmark = !vm.userHasBookmark;
				});
			};

			vm.openImage = function() {
				$('.slick-current').find('a')[0].click();
			};

			vm.addComment = () => {
				if(vm.routeData.newComment === '' || !vm.routeData.newComment){
					vm.emptyCommentError = true;
					vm.commentAddError = true;
					vm.commentAddErrorMessage = 'comment_is_required';
				}else{
					publicObjectsService.addComment(vm.routeData).then((res) => {
						if(res.data === 'ok'){
							vm.commentError = false;
							vm.emptyCommentError = false;
							vm.commentAddSuccess = true;
							vm.addCommentMessage = 'comment_notification';
							vm.routeData.newComment = '';
						}
					});
				}
			};
		},

		template: require('./route-details.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/routes/route_details_directives/route-details.directive.js
 **/